import React from "react";

// Define the props that the Button can accept
interface ButtonProps {
    children: React.ReactNode; // The content inside the button (text, icons, etc.)
    primary?: boolean; //  If true, the button will use the "primary" styling
}
// Button component definition
const Button: React.FC<ButtonProps> = ({ children, primary }) => {
    return (
        <button
            className={`group px-6 py-3 rounded-lg font-semibold inline-flex items-center justify-center gap-2 transition-transform duration-200 ease-in-out
        ${primary
                ? "bg-gradient-to-r from-orange-500 to-red-500 text-white font-bold hover:scale-105"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`}
        >
            {children} {/* Render whatever content is passed inside <Button> */}
        </button>
    );
};

export default Button;